module.exports = __webpack_public_path__ + "img/dashboard2.d2318ecf.png";